import React from "react";
import "../../../svg.css";
import { connect } from "react-redux";
import { getDesc } from "../../../stores/actions/nomenclature";

const wordWrap = (str, maxWidth) => {
  var newLineStr = "\n";
  var done = false;
  var res = "";

  do {
    var found = false;
    for (var i = maxWidth - 1; i >= 0; i--) {
      if (testWhite(str.charAt(i))) {
        res = res + [str.slice(0, i), newLineStr].join("");
        str = str.slice(i + 1);
        found = true;
        break;
      }
    }
    if (!found) {
      res += [str.slice(0, maxWidth), newLineStr].join("");
      str = str.slice(maxWidth);
    }

    if (str.length < maxWidth) done = true;
  } while (!done);

  let wordwraped = res + str;
  
  return wordwraped.split("\n");
};

const testWhite = x => {
  var white = new RegExp(/^\s$/);
  return white.test(x.charAt(0));
};
const ExplainCUFeatures = props => {
  let wordwraped_desc = [];
  let box_height = 0;
  let options_package = "";
  let option_desc = <React.Fragment />;
  var modeldef = [
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" },
    { code: "#", desc: "#####" }
  ];
  if (
    typeof props.compare != "undefined" &&
    typeof props.compare.nomenclature != "undefined"
  ) {
   
    let type = props.type;
    // if (typeof type === "undefined") type = props.type;

    var nomenclature = props.compare.nomenclature.filter(item => {
      if (item.name === type) return item;
    });
    if (nomenclature.length > 0) nomenclature = nomenclature[0];

   
    if (
      typeof props.modelnumber != "undefined" &&
      props.modelnumber.length >= 12
    ) {
      let modelno = props.modelnumber;
      if (props.modelnumber.length >= 17) {
        options_package =
          modelno[12] + modelno[13] + modelno[14] + modelno[15] + modelno[16];
        modelno = props.modelnumber;
      } else {
        /*modelno[12] = "A";
        modelno[13] = "0";
        modelno[14] = "0";
        modelno[15] = "0";
        modelno[16] = "0";*/
        options_package = "#####";
        modelno = props.modelnumber + options_package;
      }

      

      modeldef[0] = {
        code: modelno[0],
        desc: getDesc(nomenclature.nomenclature[0].trans, modelno[0])
      };
      modeldef[1] = {
        code: modelno[1],
        desc: getDesc(nomenclature.nomenclature[1].trans, modelno[1])
      };
      modeldef[2] = {
        code: modelno[2],
        desc: getDesc(nomenclature.nomenclature[2].trans, modelno[2])
      };
      modeldef[3] = {
        code: modelno[3] + modelno[4] + modelno[5] + modelno[6],
        desc: getDesc(
          nomenclature.nomenclature[3].trans,
          modelno[3] + modelno[4] + modelno[5] + modelno[6]
        )
      };
      modeldef[4] = {
        code: modelno[7],
        desc: getDesc(nomenclature.nomenclature[4].trans, modelno[7])
      };
      modeldef[5] = {
        code: modelno[8],
        desc: getDesc(nomenclature.nomenclature[5].trans, modelno[8])
      };
      modeldef[6] = {
        code: modelno[9],
        desc: getDesc(nomenclature.nomenclature[6].trans, modelno[9])
      };
      modeldef[7] = {
        code: modelno[10],
        desc: getDesc(nomenclature.nomenclature[7].trans, modelno[10])
      };
      modeldef[8] = {
        code: modelno[11],
        desc: getDesc(nomenclature.nomenclature[8].trans, modelno[11])
      };
      modeldef[9] = {
        code:
          modelno[12] + modelno[13] + modelno[14] + modelno[15] + modelno[16],
        desc: getDesc(
          nomenclature.nomenclature[9].trans,
          modelno[12] + modelno[13] + modelno[14] + modelno[15] + modelno[16]
        )
      };
      if (typeof modeldef[9].desc !== "string") {
        box_height = 100;
        option_desc = modeldef[9].desc;
      } else {
        wordwraped_desc = wordWrap(modeldef[9].desc, 39);
        box_height = wordwraped_desc.length * 20 + 20;
        if (box_height < 100) box_height = 100;
       
        option_desc = wordwraped_desc.map((text, index) => {
          return (
            <tspan key={text} x="0" y={index * 20}>
              {text}
            </tspan>
          );
        });
      }

      //return wordwraped_desc;
    }
  }
  let brandbox = <rect className="cls-1" y="113" width="108" height="38" />;
  if (typeof modeldef[0].desc != "string") {
    brandbox = (
      <path
        className="cls-1"
        d="M0 113 L0 210 L190 210 L190 160 L105 160 L105 113 Z"
      />
    );
  }

  return (
    <React.Fragment>
      <p>
        <strong>Your New Model Number</strong>
      </p>

      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 290"
        style={{ width: "100%" }}
      >
        <rect className="cls-5" x="30.75" y="61" width="3" height="65" />
        <rect className="cls-5" x="111" y="61" width="3" height="68" />
        <rect className="cls-5" x="111" y="104" width="3" height="150" />
        <rect className="cls-5" x="180" y="61" width="3" height="68" />
        <rect className="cls-5" x="263" y="61" width="3" height="68" />
        <rect className="cls-5" x="263" y="122" width="3" height="68" />
        <rect className="cls-5" x="363" y="61" width="3" height="68" />
        <rect className="cls-5" x="435" y="61" width="3" height="68" />
        <rect className="cls-5" x="435" y="112" width="3" height="68" />
        <rect className="cls-5" x="506" y="61" width="3" height="68" />
        <rect className="cls-5" x="566" y="61" width="3" height="68" />
        <rect className="cls-5" x="566" y="112" width="3" height="68" />
        <rect className="cls-5" x="650" y="61" width="3" height="68" />
        <rect className="cls-5" x="762" y="61" width="3" height="68" />
        <rect className="cls-5" x="762" y="112" width="3" height="68" />

        {brandbox}

        <rect className="cls-1" x="116" y="113" width="145" height="38"></rect>
        <rect className="cls-1" x="272" y="113" width="150" height="38" />
        <rect className="cls-1" x="445" y="113" width="115" height="38" />
        <rect className="cls-1" x="575" y="113" width="170" height="38" />
        <rect className="cls-1" x="212" y="170" width="120" height="38" />
        <rect className="cls-1" x="90" y="224" width="180" height="38" />
        <rect className="cls-1" x="348" y="170" width="130" height="38" />
        <rect className="cls-1" x="505" y="170" width="176" height="38" />
        <rect className="cls-1" x="710" y="170" width="280" height="100" />

        <rect className="cls-2" x="0" width="64" height="64" rx="12" ry="12" />
        <rect
          className="cls-2"
          x="70.67"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="142"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="333.25"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="404.67"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="476.25"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="548"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="619.5"
          width="64"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="212.13"
          width="114"
          height="64"
          rx="12"
          ry="12"
        />
        <rect
          className="cls-2"
          x="690.67"
          width="164"
          height="64"
          rx="12"
          ry="12"
        />
        <text className="cls-3" transform="translate(2 135)">
          {modeldef[0].desc}
        </text>
        <text className="cls-3" transform="translate(100 250)">
          {modeldef[1].desc}
        </text>
        <text className="cls-3" transform="translate(117 136.23)">
          {modeldef[2].desc}
        </text>
        <text className="cls-3" transform="translate(219.49 195)">
          {modeldef[3].desc}
        </text>
        <text className="cls-3" transform="translate(275 136.23)">
          {modeldef[4].desc}
        </text>
        <text className="cls-3" transform="translate(357.49 193.23)">
          {modeldef[5].desc}
        </text>
        <text className="cls-3" transform="translate(464.49 136.23)">
          {modeldef[6].desc}
        </text>
        <text className="cls-3" transform="translate(514.49 193.23)">
          {modeldef[7].desc}
        </text>
        <text className="cls-3" transform="translate(580  136.23)">
          {modeldef[8].desc}
        </text>

        <text className="cls-3" transform="translate(717 190)">
          {option_desc}
        </text>

        <text
          className="cls-4"
          transform={
            modeldef[0].code === "M"
              ? "translate(8 45)"
              : "translate(15.58 48.7)"
          }
        >
          {modeldef[0].code === "M" ? "⍦" : modeldef[0].code}
        </text>
        <text className="cls-4" transform="translate(85.58 48.7)">
          {modeldef[1].code}
        </text>
        <text className="cls-4" transform="translate(156.58 48.7)">
          {modeldef[2].code}
        </text>
        <text className="cls-4" transform="translate(215.52 48.7)">
          {modeldef[3].code}
        </text>
        <text className="cls-4" transform="translate(348.58 48.7)">
          {modeldef[4].code}
        </text>
        <text className="cls-4" transform="translate(419.58 48.7)">
          {modeldef[5].code}
        </text>
        <text className="cls-4" transform="translate(492.58 48.7)">
          {modeldef[6].code}
        </text>
        <text className="cls-4" transform="translate(562.58 48.7)">
          {modeldef[7].code}
        </text>
        <text className="cls-4" transform="translate(634.58 48.7)">
          {modeldef[8].code}
        </text>
        <text className="cls-4 extraspace" transform="translate(697.17 48.7)">
          {options_package}
        </text>
      </svg>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(ExplainCUFeatures);
